import { PageId } from 'constants/pages'

export const enum PageIdStylioPlus {
  AGE_STYLIO_PLUS = PageId.AGE_STYLIO_PLUS,
  URGE_STYLIO_PLUS = PageId.URGE_STYLIO_PLUS,
  HAIR_COLOR_STYLIO_PLUS = PageId.HAIR_COLOR_STYLIO_PLUS,
  EYES_COLOR_STYLIO_PLUS = PageId.EYES_COLOR_STYLIO_PLUS,
  JEWELRY_STYLIO_PLUS = PageId.JEWELRY_STYLIO_PLUS,
  BODY_SHAPE_STYLIO_PLUS = PageId.BODY_SHAPE_STYLIO_PLUS,
  STYLIO_TO_HELP_STYLIO_PLUS = PageId.STYLIO_TO_HELP_STYLIO_PLUS,
  TALL_STYLIO_PLUS = PageId.TALL_STYLIO_PLUS,
  WEIGHT_STYLIO_PLUS = PageId.WEIGHT_STYLIO_PLUS,
  HIGHLIGHT_LOOK_STYLIO_PLUS = PageId.HIGHLIGHT_LOOK_STYLIO_PLUS,
  CLOTHES_FIT_STYLIO_PLUS = PageId.CLOTHES_FIT_STYLIO_PLUS,
  URGE_2_STYLIO_PLUS = PageId.URGE_2_STYLIO_PLUS,
  SHOPPING_STYLIO_PLUS = PageId.SHOPPING_STYLIO_PLUS,
  STYLE_MOST_MATTERS_STYLIO_PLUS = PageId.STYLE_MOST_MATTERS_STYLIO_PLUS,
  FAVORITE_COLORS_STYLIO_PLUS = PageId.FAVORITE_COLORS_STYLIO_PLUS,
  LIKE_OR_DISLIKE_STYLIO_PLUS = PageId.LIKE_OR_DISLIKE_STYLIO_PLUS,
  LIKE_OR_DISLIKE_11_STYLIO_PLUS = PageId.LIKE_OR_DISLIKE_11_STYLIO_PLUS,
  LIKE_OR_DISLIKE_12_STYLIO_PLUS = PageId.LIKE_OR_DISLIKE_12_STYLIO_PLUS,
  LIKE_OR_DISLIKE_13_STYLIO_PLUS = PageId.LIKE_OR_DISLIKE_13_STYLIO_PLUS,
  LIKE_OR_DISLIKE_14_STYLIO_PLUS = PageId.LIKE_OR_DISLIKE_14_STYLIO_PLUS,
  LIKE_OR_DISLIKE_15_STYLIO_PLUS = PageId.LIKE_OR_DISLIKE_15_STYLIO_PLUS,
  LIKE_OR_DISLIKE_16_STYLIO_PLUS = PageId.LIKE_OR_DISLIKE_16_STYLIO_PLUS,
  LIKE_OR_DISLIKE_17_STYLIO_PLUS = PageId.LIKE_OR_DISLIKE_17_STYLIO_PLUS,
  STYLES_FEEL_LIKE_YOU_STYLIO_PLUS = PageId.STYLES_FEEL_LIKE_YOU_STYLIO_PLUS,
  URGE_4_STYLIO_PLUS = PageId.URGE_4_STYLIO_PLUS,
  BRAND_STYLIO_PLUS = PageId.BRAND_STYLIO_PLUS,
  FIND_NEW_CLOTHES_STYLIO_PLUS = PageId.FIND_NEW_CLOTHES_STYLIO_PLUS,
  NOTHING_TO_WEAR_STYLIO_PLUS = PageId.NOTHING_TO_WEAR_STYLIO_PLUS,
  OLD_CLOTHES_STYLIO_PLUS = PageId.OLD_CLOTHES_STYLIO_PLUS,
  COMBINE_CLOTHES_STYLIO_PLUS = PageId.COMBINE_CLOTHES_STYLIO_PLUS,
  OPTIMIZE_BUDGET_STYLIO_PLUS = PageId.OPTIMIZE_BUDGET_STYLIO_PLUS,
  URGE_3_STYLIO_PLUS = PageId.URGE_3_STYLIO_PLUS,
  PREPARE_FLOW_STYLIO_PLUS = PageId.PREPARE_FLOW_STYLIO_PLUS,
  EMAIL_STYLIO_PLUS = PageId.EMAIL_STYLIO_PLUS,
  EMAIL_CONSENT_STYLIO_PLUS = PageId.EMAIL_CONSENT_STYLIO_PLUS,
  NAME_STYLIO_PLUS = PageId.NAME_STYLIO_PLUS,
  SUBSCRIPTIONS_STYLIO_PLUS = PageId.SUBSCRIPTIONS_STYLIO_PLUS,
  LAST_CHANCE_OFFER_STYLIO_PLUS = PageId.LAST_CHANCE_OFFER_STYLIO_PLUS,
  CANCEL_OFFER_STYLIO_PLUS = PageId.CANCEL_OFFER_STYLIO_PLUS,
  SUB_UPSELL_STYLIO_PLUS = PageId.SUB_UPSELL_STYLIO_PLUS,
  UPSELL_STYLIO_PLUS = PageId.UPSELL_STYLIO_PLUS,
  DOWNLOAD_STYLIO_PLUS = PageId.DOWNLOAD_STYLIO_PLUS,
}
